import { useUser } from "@clerk/clerk-react";
import { Navigate } from "react-router-dom";

export const AdminRoute = ({ children }) => {
  const { user } = useUser();

  if (!user) {
    return <Navigate to="/sign-in" />;
  }

  const isAdmin = user.publicMetadata?.role === "admin"; 

  return isAdmin ? children : <Navigate to="/forbidden" replace />;
};
